<template>
    <with-first-parent :show="withRedirect">
        <router-link
            class="gst-logo"
            :to="{ name: 'dashboard' }">
            <LogoIcon
                class="gst-logo-icon"
                :is-minimized="isMinimized" />
        </router-link>
    </with-first-parent>
</template>

<script>
import { WithFirstParent } from '@components/enhancers';
import LogoIcon from './LogoIcon';

export default {
    name: 'Logo',
    components: {
        LogoIcon,
        WithFirstParent,
    },
    props: {
        isMinimized: {
            type: Boolean,
            default: false,
        },
        to: {
            type: Object,
            default: function () {
                return {};
            },
        },
        withRedirect: {
            type: Boolean,
            default: true,
        },
    },
};
</script>

<style lang="scss">
.gst-logo-icon {
    width: 100%;
}
</style>
